import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { Permissions } from 'src/app/models/Enums/Permissions';
import { PermissionService } from 'src/app/services/permission/permission.service';
@Directive({
  selector: '[hasPermission]',
})
export class HasPermissionDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
  ) {}

  @Input() set hasPermission(permission: Permissions | Permissions[]) {
    const has = Array.isArray(permission)
      ? this.permissionService.hasAnyPermission(permission)
      : this.permissionService.hasPermission(permission);

    this.viewContainer.clear();
    if (has) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
